export default {
  APPLICATION_LOG(state, payload) {
    state.applicationlog = payload;
  },
  ERROR_LOGS(state,payload){
    state.errorlog=payload
  }

};
